module.exports = __webpack_public_path__ + "img/templeofra_tech_Normal_ua.07e12642.webp";